<template lang="pug">
  footer.footerbar
    .footerbar__credits
      img.footerbar__logo(src='~@/assets/images/01.png', alt='')
      .footerbar__legal
        .legal__title
          span Юр. документы
        .legal__item
          a(:href="policyUrl" target="_blank") Политика конфиденциальности
          <br>
          a(:href="agreementUrl" target="_blank") Согласия на обработку персональных данных
          <br>
          span © 2020 constructorplus (все права защищены)
          <br>
          a(:href="offerUrl" target="_blank") Договор оферты
      .footerbar__social.social(v-if="false")
        .social__label Мы в соц. сетях:
        ul.social__list
          li.social__item
            a(href="https://vk.com/public182402926" target="_blank").social__link
              img(
                src="@/assets/images/icons/vk-icon-logo.png"
                srcset="@/assets/images/icons/vk-icon-logo@2x.png"
                alt="Страница ConPlus Вконтакте"
              )
          li.social__item
            a(href="https://fb.me/conpluscom" target="_blank").social__link
              img(
                src="@/assets/images/icons/fb-icon-logo.png"
                srcset="@/assets/images/icons/fb-icon-logo@2x.png"
                alt="Страница ConPlus в Фейсбуке"
              )
          li.social__item
            a(href="https://www.instagram.com/construktorplus/" target="_blank").social__link
              img(
                src="@/assets/images/icons/ig-icon-logo.png"
                alt="Страница ConPlus в инстаграме"
                srcset="@/assets/images/icons/ig-icon-logo@2x.png"
              )
          li.social__item
            a(href="https://t.me/ConPlus" target="_blank").social__link
              img(
                src="@/assets/images/icons/telegram.png"
                srcset="@/assets/images/icons/telegram.png"
                alt="Канал ConPlus в Телеграме"
              )

      .footerbar__contacts.contacts
        .contacts__title Служба поддержки:
        .contacts__item(v-if="true")
          span.contacts__label telegram:
          a.contacts__contact(href="https://t.me/conplus_support_bot" target="_blank") @conplus_support_bot
        .contacts__item
          span.contacts__label email:
          a.contacts__contact(:href='"mailto: " + supportEmail') {{ supportEmail }}
</template>

<style lang="scss" scoped>
@import '~@/assets/scss/core.scss';

.footerbar {
  background: #fff;
  padding: 15px;
  border-top: 1px solid #c79b74;
  position: relative;

  &::after {
    content: '';
    background: none;
    border-top: 5px solid _palette(borders, light);
    display: none;
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    pointer-events: none;
  }
}

.footerbar__credits {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.footerbar__logo {
  margin-right: 10%;
  width: 80px;
}

.social {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;

  &__label {
    text-align: center;
    margin-bottom: 8px;
  }

  &__list {
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: center;
    list-style: none;
  }

  &__item {
    margin-right: 16px;
    cursor: pointer;
    transition: transform 0.2s ease;

    &:hover {
      transform: scale(1.1);
    }

    &:last-child {
      margin-right: 0;
    }
  }

  &__link img {
    width: 37px;
  }
}

.contacts {
  &__label {
    font-weight: 600;
    margin-right: 6px;
  }
}

@media screen and (max-width: 768px) {
  .footerbar::after {
    display: block;
  }
}

@media screen and (max-width: 640px) {
  .footerbar__credits {
    flex-wrap: wrap;
    text-align: right;
  }
  .social {
    align-items: flex-end;

    &__label {
      display: none;
    }
  }

  .contacts {
    margin-top: 10px;
    flex-basis: 100%;
    text-align: right;

    &__item {
      align-items: flex-end;
    }
  }
}

@media screen and (max-width: 480px) {
  .footerbar__credits,
  .contacts {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .footerbar__logo,
  .footerbar__legal,
  .social,
  .contacts {
    margin: 0.5em 0;
  }

  /*.social {
    order: -1;
    width: 60%;
    flex: none;
  }

  .footerbar__logo {
    order: -1;
  }

  .contacts {
    flex-basis: 0;
  }

  .footerbar__legal {
    margin-top: 10px;
  }*/
}
</style>

<script>
import config from '@/config';
export default {
  computed: {
    supportEmail: () => config.supportEmail,
    offerUrl: () => config.urls.offer,
    policyUrl: () => config.urls.policy,
    agreementUrl: () => config.urls.agreement
  }
};
</script>
